import PropTypes from 'prop-types';

import { getContent, isWHEnv } from '@/utils/helper';
import cn from 'classnames';

import Card from '@/molecules/Card/Card';
import StoryRecipeSteps from '../Story/StoryRecipeSteps';
import Story from '../Story/Story';
import SectionHeader from '@/molecules/SectionHeader/SectionHeader';
import ProductsKind from '../ProductsKind/ProductsKind';

function ContentGrid({
  assets = [],
  entries = [],
  fields = null,
  noPadding = false,
  className = '',
  overflowX = false,
  columnLayout,
  cardImageClassName,
  leftContent: LeftContent,
  isFromTwoColumnContent = false,
  isFromContentColumn = false,
  hasBackground,
}) {
  // @TODO: Improve variable spreading and type checking.
  const { cards, name, contentCta: cta, backgroundColor } = fields;

  if (!cards) return null;

  return (
    <div
      className={cn('content-grid-wrapper relative', {
        [`bg-${backgroundColor}`]: backgroundColor !== undefined,
        'pt-8': isWHEnv(),
      })}
    >
      <div
        className={`aaco-content-grid ${noPadding || 'container mx-auto'} ${
          isFromTwoColumnContent ? 'pb-20' : 'pb-10'
        } ${className} dd-kr:mb-0 dd-en:mb-0 `}
        aria-label={name}
      >
        <div className={`w-full  ${isWHEnv() ? 'wh-grid-wrap' : ''}`}>
          <div
            className={`grid grid-sequence ${
              overflowX ? ' grid-cols-content-grid-overflow-x' : 'grid-cols-1'
            } ${
              columnLayout
                ? 'grid-cols-1 dd-kr:gap-x-[30px] dd-en:gap-x-[30px]'
                : 'md:grid-cols-3 dd-kr:md:gap-x-[60px] dd-en:md:gap-x-[60px]'
            }  gap-x-[60px] gap-y-[60px] md:gap-y-[35px] dd-en:gap-y-[40px] dd-kr:gap-y-[40px] dd-en:md:gap-y-[60px] dd-kr:md:gap-y-[60px]`}
          >
            {LeftContent}
            {cards.length > 0 &&
              cards.map((card, index) => {
                if (!card) {
                  return;
                }

                const contentCta = getContent(cta?.sys?.id, entries);
                if (card.sys) {
                  const content = getContent(card.sys.id, entries);

                  if (content?.sys?.contentType?.sys?.id === 'story')
                    return (
                      <Story
                        fields={content.fields}
                        assets={assets}
                        entries={entries}
                        key={card.sys.id}
                      />
                    );
                  if (content?.sys?.contentType?.sys?.id === 'sectionHeader')
                    return (
                      <SectionHeader
                        fields={content.fields}
                        entries={entries}
                        key={card.sys.id}
                      />
                    );
                  if (content?.sys?.contentType?.sys?.id === 'productKind')
                    return (
                      <ProductsKind
                        fields={content.fields}
                        entries={entries}
                        key={card.sys.id}
                      />
                    );
                  return (
                    <div
                      key={card.sys.id + index}
                      className={`mb-[35px] md:mb-0 ${
                        overflowX ? ' mr-8' : ''
                      } md:mr-0 dd-kr:mr-0 dd-en:mr-0`}
                    >
                      <Card
                        fields={content?.fields}
                        assets={assets}
                        entries={entries}
                        cardImageClassName={cardImageClassName}
                        contentCta={contentCta}
                        isFromTwoColumnContent={isFromTwoColumnContent}
                        isFromContentColumn={isFromContentColumn}
                        hasBackground={hasBackground}
                      />
                    </div>
                  );
                } else {
                  //handles dynamic grid
                  return (
                    <div
                      key={card.id ? card.id + index : index}
                      className={`dd-en:last:mb-0 dd-kr:last:mb-0 ${
                        overflowX && ' mr-8'
                      } md:mx-auto md:my-0 dd-kr:mr-0 dd-en:mr-0 xl:w-full dd-kr:w-full dd-en:w-full`}
                    >
                      <Card
                        fields={fields?.cards?.[index]}
                        assets={assets}
                        entries={entries}
                        cardImageClassName={cardImageClassName}
                        contentCta={contentCta?.fields}
                        isFromTwoColumnContent={isFromTwoColumnContent}
                        isFromContentColumn={isFromContentColumn}
                        hasBackground={hasBackground}
                      />
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

// @TODO: define real props for the ContentGrid based on it requirements
ContentGrid.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
  noPadding: PropTypes.bool,
  overflowX: PropTypes.bool,
  className: PropTypes.string,
  cardImageClassName: PropTypes.string,
};

export default ContentGrid;
